import React from "react";
import {Drawer, IconButton, List, TextField} from "@material-ui/core";
import {ArrowBack as ArrowBackIcon, Home} from "@material-ui/icons";
import {withRouter} from "react-router-dom";
import classNames from "classnames";
import _ from 'lodash'

// styles
import useStyles from "./styles";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useTheme} from '@material-ui/core/styles';

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import AssignmentIcon from '@material-ui/icons/Assignment';

// context
import {search_sidebar, toggleSidebar, useLayoutDispatch, useLayoutState} from "../../context/LayoutContext";
import {connect} from "react-redux";
import {dynamicStringSort} from "../../utils";


function Sidebar({location, profile}) {
    var classes = useStyles();
    const theme = useTheme();

    // global
    var {isSidebarOpened, search} = useLayoutState();
    var layoutDispatch = useLayoutDispatch();
    const isMobile = !useMediaQuery(theme.breakpoints.up('sm'))

    // local
    const isPermanent = !isMobile;

    const buildSidebarStructure = (e, i) => ({
        id: i,
        label: e.name,
        link: "",
        icon: <img src={e.logo} alt="logo" style={{width: 40, height: 40}}/>,
        children: e.jobs.map(_ => ({label: _.title, link: `/app/job/${_.id}`})),
    });

    const lower_search = search.toLowerCase()

    const is_searched = (data, searchquery) => {
        searchquery = searchquery.toLowerCase()
        return data.reduce((acc, j) => [
                j.title.toLowerCase().indexOf(searchquery) > -1,
                j.id.toString().toLowerCase().indexOf(searchquery) > -1,
                j.id_in_source.toLowerCase().indexOf(searchquery) > -1,
            ].reduce((c_acc, c) => c_acc || c, false)
            || acc, false);
    };

    const applySearch = (raw) => {
        if (!Object.keys(raw).length) {
            return [];
        }

        let new_tree = [];
        [...raw.companies].filter((e) => {
            if (!lower_search.length) {
                new_tree.push(e);
                return true;
            }
            if (e.name.toLowerCase().indexOf(lower_search) > -1) {
                new_tree.push(e);
                return true;
            }
            if (is_searched(e.jobs, lower_search)) {
                const filter_jobs = [...e.jobs].filter((e) => is_searched([e], lower_search));
                new_tree.push({...e, jobs: filter_jobs});
                return true;
            }
            return false;
        });
        [...raw.agencies].filter((e) => {
            if (!lower_search.length) {
                new_tree.push(...e.companies);
                return true;
            }
            if (e.name.toLowerCase().indexOf(lower_search) > -1) {
                new_tree.push(...e.companies);
                return true;
            }
            return false;
        })
        const new_tree_jobs = new_tree.map(x => x.jobs.map((e)=>({...e, logo:x.logo}))).reduce(function(a, b){
            return a.concat(b);
        }, []);
        const new_tree_uniq_jobs = _.uniqBy(new_tree_jobs, 'id');
        const new_tree_company_grouped = _.groupBy(new_tree_uniq_jobs, 'company');
        const new_tree_shaped = Object.entries(new_tree_company_grouped).map((k, v) => ({name: k[0], logo: k[1][0].logo, jobs: k[1]}));
        const sorted = new_tree_shaped.sort(dynamicStringSort("name"));
        return sorted.map(buildSidebarStructure);
    };

    const onSearch = (event) => {
        search_sidebar(layoutDispatch, event.target.value);
    };

    function SideBarList({profile}) {
        if (profile.offers && profile.offers.length) {
            return (
                [
                    {label: "Übersicht", link: "/app/dashboard", icon: <Home/>, id: -1},
                    {label: "Ihre Buchungen", link: "/app/offers", icon: <AssignmentIcon/>, id: -3},
                    {type: 'divider', id: -2}
                ]
            )
        } else {
            return (
                [
                    {label: "Übersicht", link: "/app/dashboard", icon: <Home/>, id: -1},
                    {type: 'divider', id: -2}
                ]
            )
        }
    }

    function CreateList({profile}) {
        return (
            <>
                {<List className={classes.sidebarList}>
                    {
                        SideBarList({profile}).map(link => (
                            <SidebarLink
                                className={classes.sideBarItem}
                                key={link.id}
                                location={location}
                                isSidebarOpened={isSidebarOpened}
                                {...link}
                            />
                        ))}
                </List>}
            </>
        )
    }

    return (
        <Drawer
            variant={isPermanent ? "permanent" : "temporary"}
            className={classNames(classes.drawer, {
                [classes.drawerOpen]: isSidebarOpened,
                [classes.drawerClose]: !isSidebarOpened,
            })}
            classes={{
                paper: classNames({
                    [classes.drawerOpen]: isSidebarOpened,
                    [classes.drawerClose]: !isSidebarOpened,
                }),
            }}
            open={isSidebarOpened}
        >
            <div className={classes.toolbar}/>
            <div className={classes.mobileBackButton}>
                <IconButton onClick={() => {
                    toggleSidebar(layoutDispatch);
                }}>
                    <ArrowBackIcon
                        classes={{
                            root: classNames(classes.headerIcon, classes.headerIconCollapse),
                        }}
                    />
                </IconButton>
            </div>
            <div className={classes.topMenu}>
                <CreateList profile={profile}/>
                <TextField className={classes.searchlist} value={search} label="Stellentitel, Firma, Id..."
                           onChange={onSearch}/>
                <List className={classes.sidebarList}>
                    {applySearch(profile).map(link => (
                        <SidebarLink
                            key={link.id}
                            location={location}
                            isSidebarOpened={isSidebarOpened}
                            {...link}
                        />
                    ))}
                </List>
            </div>
        </Drawer>
    );
}

const mapStateToProps = reducer_state => {
    return {
        profile: reducer_state.profile,
    };
};


export default withRouter(connect(mapStateToProps)(Sidebar));
